module.exports = __webpack_public_path__ + "static/specificity1-a20b1665677c1ea213adefeca98ee0c5.png";